import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ChartType} from 'chart.js';
import { ChartComponent } from './chart.component';
import { PersianService } from 'projects/sepidz-web-framework/src/lib/services/persian.service';

@Component({
  selector: 'sepidz-bar-chart',
  template: `
      <div class="card" style = "background : var(--bg-light) ; color: var(--color-text-dark); border-radius:10px ;height: 100%;">
          <div class="cardheader" style = "font-size: 0.8rem; padding:1vmin;">
              {{ title }}
          </div>
          <div class="cardbody">
              <canvas *ngIf="!isLoading"
                      baseChart
                      [plugins]="plugins"
                      [datasets]="datasetList"
                      [labels]="labels"
                      [options]="options"
                      [colors]="colors"
                      [legend]="legend"
                      [chartType]="type"
              ></canvas>
          </div>
      </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BarChartComponent extends ChartComponent {
  @Input() labelField = 'Name';
  @Input() valueField = 'Value';
  public type: ChartType = 'bar';

  constructor(httpClient: HttpClient, persian: PersianService) {
    super(httpClient, persian);
  }

  protected init() {
    super.init();
    this.options.legend.position = 'bottom';
    this.options.legend.labels.padding = 10;
  }

  protected loaded(data: any[]) {
    if (this.legendLabels.length > 1) {
      const datasetList = [...this.datasetList];
      datasetList.forEach(dataset => dataset.data.length = 0);
      data.forEach((dataItem: Array<any>) => {
          (dataItem as Array<any>).forEach(item => {
            if (this.labels.indexOf(item[this.labelField]) === -1) {
              this.labels.push(item[this.labelField]);
            }
          });

          for (let i = 0; i < dataItem.length; i++) {
            datasetList[i].data.push(dataItem[i][this.valueField]);
          }
        }
      );
      this.datasetList = [...datasetList];
    } else {
      data.forEach(item => {
        if (this.labels.indexOf(item[this.labelField]) === -1) {
          this.labels.push(item[this.labelField]);
        }
      });
      this.datasetList[0].data = data.map(c => c[this.valueField]);
    }
  }
}
